<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CustomLoader from "@/components/widgets/custom-loader";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import excel from "vue-excel-export";
Vue.use(excel);
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Manage Students",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
  },
  data() {
    return {
      title: "Manage Students",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Manage Students",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [10, 25, 50, 100, 200],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "Action",
        },
        {
          key: "student",
          label: "Student's Name",
          sortable: true,
        },
        {
          key: "gender",
          label: "Gender",
          sortable: true,
        },
        {
          key: "classx",
          label: "Level",
          sortable: true,
        },
        {
          key: "course.name",
          label: "Course",
          sortable: true,
        },
        {
          key: "guardian",
          label: "Parent",
          sortable: true,
        },
        {
          key: "address",
          label: "Home Residence",
          sortable: true,
        },
        {
          key: "contact",
          label: "Contact(s)",
          sortable: true,
        },
      ],
      data: {
        name: "",
        photo: "",
        dob: "",
        gender: "",
        class: "",
        course: "",
        entryTerm: "",
        entryStatus: "",
        residence: "",
        code: "",
        lin: "",
        stdContact: "",
        occupation: "",
        email: "",
        address: "",
      },
      upload: {
        class: "",
        course: "",
        studentFile: "",
      },
      deleteStudent: {
        name: "",
        id: "",
      },
      existingStudent: [],
      errors: {
        name: "",
        photo: "",
        dob: "",
        gender: "",
        class: "",
        course: "",
        entryTerm: "",
        entryStatus: "",
      },
      modal: "",
      filterData: {
        class: "",
        course: "",
        year: "",
      },
      selectedStream: [],
      selectedClass: [],
      toggleSearch: "none",
      searchedStudents: [],
      json_fields: {
        Name: "student.name",
        Class: "classx.short",
        Stream: "streamx.name",
        Gender: "student.gender",
        "Home Residence": "student.resident",
        "Parent Name": "student.guardian",
        "Parent Contact": "student.gcontacts",
        "Payment Code": "student.code",
        "LIN Number": "student.lin",
      },
    };
  },
  computed: {
    ...mapGetters("students", [
      "AllStudents",
      "SaveStatus",
      "FetchingStudents",
      "getAllSearchableStudents",
    ]),
    ...mapGetters("classes", [
      "AllCourses",
      "AllClasses",
      "AllClassStreams",
      "CustomClasses",
    ]),
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllStudents ? this.AllStudents.length : 1;
    },
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        // this.closeModal(this.modal);
      }
    },
    // AllStreams() {
    //   this.selectClassStream();
    // },
    // AllClasses() {
    //   this.selectClassStream();
    // },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllStudents ? this.AllStudents.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStudents: "students/fetchStudents",
      UploadStudent: "students/uploadStudent",
      AddStudent: "students/addStudent",
      DeleteStudents: "students/deleteStudents",
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchYears: "marks/fetchYear",
      FetchSearchableStudents: "students/fetchSearchableStudents",
      FetchCustomClasses: "classes/fetchCustomClasses",
      FetchCourses: "classes/fetchCourses",
    }),

    //Handling student's photo
    handleFileUpload(event) {
      this.data.photo = event.target.files[0];
    },

    //student's upload
    handleFileUploadStudent(event) {
      this.upload.studentFile = event.target.files[0];
    },

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllStudents.length;
      this.currentPage = 1;
    },

    resetError() {
      this.errors.name = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingStudent = this.AllStudents.filter((student) => {
          return student.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingStudent.length) {
          this.errors.name = this.data.name + " Already Exists";
        } else {
          this.errors.name = "";
        }
      } else {
        this.existingStudent = [];
      }
    },
    addStudent(modal) {
      this.modal = modal;
      let studentData = new FormData();
      //setting up form data for the uploads
      studentData.append("name", this.data.name);
      studentData.append("photo", this.data.photo);
      studentData.append("dob", this.data.dob);
      studentData.append("gender", this.data.gender);
      studentData.append("class", this.data.class);
      studentData.append("stream", this.data.stream);
      studentData.append("entryTerm", this.data.entryTerm);
      studentData.append("entryStatus", this.data.entryStatus);
      studentData.append("residence", this.data.residence);
      studentData.append("stdContact", this.data.stdContact);
      studentData.append("occupation", this.data.occupation);
      studentData.append("email", this.data.email);
      studentData.append("address", this.data.address);
      this.AddStudent(studentData);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    uploadStudent(modal) {
      this.modal = modal;
      //setting up data for upload.
      let studentUploads = new FormData();
      studentUploads.append("class", this.upload.class);
      studentUploads.append("stream", this.upload.stream);
      studentUploads.append("students_file", this.upload.studentFile);
      this.UploadStudent({
        payload: studentUploads,
        stdFilter: this.filterData,
      });
      this.resetError();
      this.resetAddModal();
      // this.closeModal(this.modal);
    },
    showDeleteModal(values) {
      this.deleteStudent.id = values.item.student.id;
      this.deleteStudent.name = values.item.student.name;
    },
    deleteStd(modal) {
      this.modal = modal;
      this.DeleteStudents({
        payload: this.deleteStudent,
        stdFilter: this.filterData,
      });
      this.closeModal(modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    fetchLevelinCourse() {
      const courseSelected = {
        course: this.filterData.course,
      };
      this.FetchCustomClasses(courseSelected);
    },

    submitFilter() {
      this.FetchStudents(this.filterData);
    },

    //searching functionality
    displayList() {
      this.toggleSearch = "block";
    },
    removeList() {
      setTimeout(() => {
        this.toggleSearch = "none";
      }, 250);
    },
    searchStudent(event) {
      this.searchedStudents = this.getAllSearchableStudents.filter(
        (student) => {
          return student.student.name
            .toLowerCase()
            .includes(event.target.value.toLowerCase());
        }
      );
    },
  },
  created() {
    this.FetchYears();
    this.FetchSearchableStudents();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_students')
        )
      "
    >
      <div class="col-12">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" role="tab" class="row">
            <div class="col-md-8 float-end">
              <h6 class="m-0">
                <a
                  v-b-toggle.accordion-1
                  class="text-primary"
                  href="javascript: void(0);"
                  ><u> Click to Filter Students</u>
                  <i class="fa fa-filter" aria-hidden="true"></i
                ></a>
              </h6>
            </div>
            <div class="col-md-4 float-end">
              <input
                type="text"
                class="form-control"
                @keyup="searchStudent($event)"
                @focusin="displayList()"
                @blur="removeList()"
                placeholder="Quick Search, Enter Student's Name."
                id=""
                style="border-radius: 2rem;"
              />
              <div
                class="list-group"
                :style="
                  `position: absolute; z-index: 1; width: 25rem; display: ${toggleSearch};`
                "
              >
                <a
                  v-if="FetchingStudents"
                  href="#"
                  class="list-group-item list-group-item-action disabled"
                  aria-current="true"
                >
                  <i class="fa fa-spinner" aria-hidden="true"></i> Fetching
                  students please wait to type....
                </a>
                <a
                  v-else
                  href="#"
                  class="list-group-item list-group-item-action disabled"
                  aria-current="true"
                >
                  Please type the name for the student to search....
                </a>
                <router-link
                  v-for="(searchableStudent, index) in searchedStudents"
                  :key="index"
                  :to="'/students/details/' + searchableStudent.sid"
                  class="list-group-item list-group-item-action"
                  aria-current="true"
                >
                  {{ searchableStudent.student.name }} | Course:
                  {{ searchableStudent.course.name }} | Level:
                  {{ searchableStudent.classx.short }}
                </router-link>
              </div>
            </div>
          </b-card-header>
          <b-collapse
            id="accordion-1"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <form @submit.prevent="submitFilter()">
                <div class="row">
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Year <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.year"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Year</option>
                        <option
                          v-for="(schyear, index) in getYears"
                          :value="schyear.year"
                          :key="index"
                        >
                          {{ schyear.year }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Course <small class="text-danger">*</small></label
                      >
                      <select
                        required
                        v-model="filterData.course"
                        class="form-control form-control-sm"
                        @change="fetchLevelinCourse()"
                      >
                        <option v-if="SaveStatus" selected value="" disabled>
                          Fetching Courses...
                        </option>
                        <option v-else selected value="" disabled>
                          Select Course
                        </option>
                        <option
                          v-for="(course, index) in AllCourses"
                          :key="index"
                          :value="course.id"
                        >
                          {{ course.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Level <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.class"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Level</option>
                        <option
                          v-for="(classes, index) in CustomClasses"
                          :key="index"
                          :value="classes.id"
                        >
                          {{ classes.short }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3 mt-3">
                    <button
                      type="submit"
                      size="sm"
                      disabled
                      class="btn btn-sm btn-outline-primary mt-2"
                      v-if="FetchingStudents"
                    >
                      <b-spinner
                        variant="primary"
                        small
                        label="Fetching Data..."
                      ></b-spinner>
                      Fetching Data...
                    </button>
                    <button
                      v-else
                      type="submit"
                      size="sm"
                      class="btn btn-sm btn-outline-primary mt-2"
                    >
                      <i class="fa fa-check"></i>
                      Submit Filers
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <CustomLoader v-if="FetchingStudents"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card" v-if="AllStudents || getAllSearchableStudents">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12">
                <h3 class="card-title text-primary">List of students</h3>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <b-button-group
                  class="mb-2 float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_student')
                    )
                  "
                >
                  <router-link
                    to="/students/new"
                    role="button"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                    Add Student
                  </router-link>
                  <export-excel
                    :data="AllStudents"
                    :fields="json_fields"
                    name="Students List.xls"
                  >
                    <b-btn variant="success" class="btn-sm">
                      <i class="fa fa-download"></i>
                      Excel
                    </b-btn>
                  </export-excel>
                </b-button-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                class="datatables student-list"
                :items="AllStudents && AllStudents.length > 0 ? AllStudents : getAllSearchableStudents"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(student)="data">
                  {{ data.item.student.name }}
                </template>
                <template #cell(actions)="data">
                  <b-dropdown size="sm">
                    <template v-slot:button-content>
                      Action
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item>
                      <router-link
                        class="text-success"
                        :to="'/students/details/' + data.item.sid"
                      >
                        <i class="bx bx-aperture"></i> Student Details
                      </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_student')
                        )
                      "
                    >
                      <router-link
                        :to="`/students/edit/${data.item.sid}`"
                        class="text-primary"
                      >
                        <i class="fa fa-edit"></i>
                        Edit Student
                      </router-link>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template #cell(residence)="data">
                  {{ data.item.residence == "1" ? "Day" : "Boarding" }}
                </template>
                <template #cell(classx)="data">
                  {{ data.item.classx.short }}
                </template>
                <template #cell(gender)="data">
                  {{ data.item.student.gender }}
                </template>
                <template #cell(streamx)="data">
                  {{ data.item.streamx.name }}
                </template>
                <template #cell(guardian)="data">
                  {{ data.item.student.guardian }}
                </template>
                <template #cell(address)="data">
                  {{
                    data.item.student.address
                      ? data.item.student.address
                      : data.item.student.resident
                  }}
                </template>
                <template #cell(contact)="data">
                  {{
                    data.item.student.contact
                      ? data.item.student.contact
                      : data.item.student.gcontacts
                  }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <span>Please Filter to View Students</span>
            </div>
          </div>
        </div>
      </div>
      <!-- modal delete Student starts -->
      <b-modal
        id="delete-student-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('cancel_student')
          )
        "
      >
        <template #modal-title>
          <h5 class="text-danger">
            Cancel Student: <strong>{{ deleteStudent.name }}</strong>
          </h5>
        </template>
        <div class="form-group mb-3">
          <div class="input-group">
            <h6 class="px-4">
              Do you want to Cancel Student,
              <strong>{{ deleteStudent.name }}</strong
              >?
              <br />
              <br />
              <strong>Click Proceed Button to Cancel.</strong>
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            data-dismiss="modal"
            @click="closeModal('delete-student-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            @click="deleteStd('delete-student-modal')"
          >
            <i class="fa fa-times-circle" aria-hidden="true"></i> Proceed
          </button>
          <b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Wait, Deleting Student"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
